import { Box, Container, VStack} from '@bpba/ui-components';
import { Banner } from '../components/Banner';
import { Title } from '../components/Title';

import { CONFIRMACION_ENTRADAS } from '../Constantes';

import ConfirmacionEntradasComponente from '../components/ConfirmacionEntradasComponente';




export const ConfirmacionEntradas: React.FC = () => {


    return (
        <Container>
            <VStack>
                <VStack>
                    <Banner borderRadius={['0px', '8px']} url={CONFIRMACION_ENTRADAS} />
                    <Box flexDirection={['column', 'row']}>
                        <Box>
                            <VStack width={'100%'} p={['24px 16px', null, null, '32px 50px']}>
                                <Title title={'Sorteo de entradas para Los Piojos'} ></Title>
                                
                            </VStack>
                        </Box>
                        <Box
                            width={["100%", "90%", "85%", "65%"]}
                            p={["50px 16px", "50px 16px", "50px 20px", "75px 40px"]}
                            mr={["0px", "15px", "20px", "50px"]}
                            bg="secondary.2"
                            minHeight={["400px", "500px", "500px"]}>
                            <ConfirmacionEntradasComponente />
                        </Box>
                    </Box>
                   
                </VStack>

            </VStack>
        </Container>

    )

}



